module.exports = __webpack_public_path__ + "img/elementlengths_jaka.56a7bd1a.png";